import * as React from "react";
import "./removableList.scss";
import IconSmall from "../../atoms/Icon/IconSmall";
import {Icon} from "../../atoms/Icon/Icon";
import {isNullOrUndefined} from "util";

interface IProps<T> {
	/**
	 * List of items.
	 */
	items: T[];
	/**
	 * Item row renderer.
	 * @param {T} item
	 * @return {JSX.Element | string}
	 */
	itemRowRenderer: (item: T) => JSX.Element | string;
	/**
	 * On delete callback.
	 * @param {string} id
	 */
	onRemove?: (item: T) => void;
	/**
	 * Is item removable
	 * @param {T} item
	 * @returns {boolean}
	 */
	isItemRemovable?: (item: T) => boolean;
}

export default class RemovableList<T> extends React.PureComponent<IProps<T>, {}> {

	public static defaultProps: Partial<IProps<any>> = {
		isItemRemovable: () => true,
	};

	render() {
		return (
			<ul className={"m-removable-list"}>
				{this.props.items.map((item, index) => {
					return (
						<li key={index}>
							<div className={"m-removable-list_item"}>{this.props.itemRowRenderer(item)}</div>
							{this.props.isItemRemovable(item) && <IconSmall icon={Icon.X}
																			variant={"scarlet"}
																			onClick={() => this.onRemove(item)}
							/>}
						</li>
					);
				})}
			</ul>
		);
	}

	/**
	 * On remove callback.
	 * @param {T} item
	 */
	onRemove(item: T) {
		if (!isNullOrUndefined(this.props.onRemove)) {
			this.props.onRemove(item);
		}
	}
}
